import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ConfigurationService } from '../../core/services/configuration.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { User } from '../../core/models/user.interface';

@Component({
  selector: 'app-layout-register',
  standalone: true,
  imports: [RouterOutlet, CommonModule, RouterModule],
  templateUrl: './layout-register.component.html',
  styleUrl: './layout-register.component.scss',
})
export class LayoutRegisterComponent implements OnInit, OnDestroy {
  user: User | null = null;
  private sub!: Subscription;

  showWelcomeMessage: boolean = false;

  // Variables para el video de YouTube
  videoUrl: SafeResourceUrl | null = null;
  showVideo = false;
  carouselInterval: any;
  isMuted = true; // Estado inicial del sonido (silenciado)
  videoId: string | null = null;

  constructor(
    private configService: ConfigurationService,
    private sanitizer: DomSanitizer,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loadBackgroundVideo();
    this.sub = this.authService.userUpdatedObservable.subscribe(user => {
      this.user = user;
      this.showWelcomeMessage = false;
      if (user == null) return;
      if (!user.status || user.status.id !== 2) return;
      this.showWelcomeMessage = true;
    });
  }

  /**
   * Carga el video de fondo desde la configuración
   */
  loadBackgroundVideo(): void {
    this.configService.getEmbeddedVideos().subscribe({
      next: (response) => {
        if (response.data?.length > 0) {
          const videoData = response.data.find((video: any) => video.type === 'video_inicio');
          
          if (videoData?.url) {
            this.videoId = this.getYoutubeVideoId(videoData.url);
            if (this.videoId) {
              this.updateVideoUrl();
              this.showVideo = true;
              return;
            }
          }
        }
      },
      error: (error) => {
        console.error('Error al obtener videos embebidos:', error);
      }
    });
  }

  /**
   * Extrae el ID del video de una URL de YouTube
   * @param url URL de YouTube
   * @returns ID del video o null si no es válida
   */
  getYoutubeVideoId(url: string): string | null {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  /**
   * Actualiza la URL del video según el estado de mute
   */
  updateVideoUrl(): void {
    if (this.videoId) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube-nocookie.com/embed/${this.videoId}?autoplay=1&mute=${this.isMuted ? '1' : '0'}&controls=0&loop=1&playlist=${this.videoId}&rel=0&modestbranding=1&fs=0&disablekb=1&iv_load_policy=3&cc_load_policy=0&autohide=1&playsinline=1&showinfo=0&showsearch=0&vq=hd1080&color=white&start=1&theme=dark&origin=${window.location.origin}`
      );
    }
  }

  /**
   * Activa o desactiva el sonido del video
   */
  toggleSound(): void {
    this.isMuted = !this.isMuted;
    this.updateVideoUrl();
  }

  ngOnDestroy(): void {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
    if (this.sub) this.sub.unsubscribe();
  }
}
